import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  warningBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    borderRadius: 4,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
    },
  },
  warningContent: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  actionButton: {
    flexShrink: 0,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8125rem',
    borderRadius: 20,
    padding: theme.spacing(0.75, 2),
    alignSelf: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'center',
      marginLeft: 'auto',
    },
  },
  detailsNotSubmittedWarning: {
    backgroundColor: '#f5f5f5',
  },
  chargesDisabledWarning: {
    backgroundColor: '#feecea',
  },
  payoutsDisabledWarning: {
    backgroundColor: '#fef5e4',
  },
}))

export default useStyles
